import {Component, OnInit} from "@angular/core";
import {
  AbstractPublicLandingPageService,
  DestroyableBase,
  LandingPageLayoutTypeComponentMap,
  LandingPageTrackingService,
  PublicLandingPageService
} from "fello-common";
import {AvailableLandingPageLayouts, LandingPageSettingsResponse} from "fello-model";
import {takeUntil, tap} from "rxjs/operators";

@Component({
  selector: "app-landing-page",
  templateUrl: "./landing-page.component.html",
  styleUrls: ["./landing-page.component.scss"],
  providers: [
    PublicLandingPageService,
    LandingPageTrackingService,
    {
      provide: AbstractPublicLandingPageService,
      useExisting: PublicLandingPageService
    }
  ],
  host: {
    class: "position-relative"
  }
})
export class LandingPageComponent extends DestroyableBase implements OnInit {
  lpCmpMap = LandingPageLayoutTypeComponentMap;
  lpSettings: LandingPageSettingsResponse<AvailableLandingPageLayouts>;

  constructor(private lpService: AbstractPublicLandingPageService<AvailableLandingPageLayouts>) {
    super();
  }

  ngOnInit(): void {
    this.lpService.landingPagePublicSetting$
      .pipe(
        takeUntil(this.isDestroyed),
        tap(settings => (this.lpSettings = settings))
      )
      .subscribe();
  }
}
